<template>
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "Authorizer"
};
</script>

<style></style>
